module.exports = __webpack_public_path__ + "static/img/hw.e8637bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/hw.png
// module id = gM2x
// module chunks = 1